require('string-format');

// var SceneManager = require('./scene-manager').SceneManager;
import {LoadScene} from './loadscene';
import {PopupScene} from './popupscene';
import LoadHandler from './load_handler';
import Init from './init';
import SETTINGS from "settings";
import Stream from "./frp/stream";
import PIXI_video_performance_fix from "PIXI_video_performance_fix"

import Server from "./network/network_api";

let rootContainer = null;
let popupScene = null;


const LOADSCREEN_RECOURCES = [
    'res/loadscreen.jpg',
    'res/loadbar.png',
    'res/common/network_indicator.png',
    'res/common/process_wait.json',
    'res/common/no_connection.json',
    'res/common/connection_failed.png'];

const COMMON_PIXI_RESOURCES = [
    'res/common/fonts/jackpot-font.png',
    'res/common/fonts/jackpot-font.xml',
    'res/common/jackpot/jackpot_table.jpg',
    'res/common/jackpot/super_table.jpg',
    'res/common/jackpot/mega_table.jpg',
    'res/common/jackpot/persones_gold.png',
    'res/common/jackpot/pers_top_left.png',
    'res/common/jackpot/pers_top_right.png',
    'res/common/jackpot/persones_silver.png',
    'res/common/jackpot/persones_bronze.png',
    'res/common/jackpot/lamp/000.png',
    'res/common/jackpot/lamp/001.png',
    'res/common/jackpot/lamp/002.png',
    'res/common/jackpot/lamp/003.png',
    'res/common/jackpot/press_collect.png',
    'res/common/jackpot/you_won.png',
    // 'res/common/jackpot/jackpot_shine_0.json',
    // 'res/common/jackpot/jackpot_shine_1.json',
    // 'res/common/jackpot/jackpot_shine_2.json',
    'res/common/jackpot/jackpot_coin.json',

    'res/common/roulette/background.jpg',
    // 'res/common/roulette/roulette_body.png',
    'res/common/roulette/arrow.png',
    'res/common/roulette/disc/disc_default.png',
    'res/common/roulette/disc/disc_blue.png',
    'res/common/roulette/disc/disc_green.png',
    // 'res/common/roulette/disc/disc_purple.png',
    'res/common/roulette/disc/disc_yellow.png',
    // 'res/common/roulette/fork.png',
    // 'res/common/roulette/trunk.png',
    // 'res/common/roulette/color_spheres_0.json',
    // 'res/common/roulette/color_spheres_1.json',
    // 'res/common/roulette/color_spheres_2.json',
    // 'res/common/roulette/jackpot_roulette.png',
    'res/common/roulette/roulette_blink.json',
    'res/common/roulette/press_start.png',
    'res/common/roulette/waiting.png',
    'res/common/roulette/roulette_digits.png',
    'res/common/roulette/roulette_digits.xml',
    'res/common/roulette/blue_substrate.png',
    'res/common/roulette/green_substrate.png',
    // 'res/common/roulette/violet_substrate.png',
    'res/common/roulette/yellow_substrate.png',
    // 'res/common/roulette/bonus.png',
    'res/common/roulette/question_mark.png',

    'res/common/progressive_jackpot/diamond_background.jpg',
    'res/common/progressive_jackpot/jp_panel.png',
    'res/common/progressive_jackpot/jp_particles.json',
    'res/common/progressive_jackpot/fonts/jp_big_digits_font.xml',
    'res/common/progressive_jackpot/jp_blick.png',
    'res/common/progressive_jackpot/jp_blick_mask.png',
    'res/common/progressive_jackpot/jp_press_start.png',

    'res/common/progressive_jackpot/galaxy_background.jpg',
    'res/common/progressive_jackpot/jp_panel_galaxy.png',
    'res/common/progressive_jackpot/headlight00.png',
    'res/common/progressive_jackpot/headlight01.png',
    'res/common/progressive_jackpot/headlight02.png',
    'res/common/progressive_jackpot/headlight03.png',

    'res/common/progressive_jackpot/particles/sparks_big/0.png',
    'res/common/progressive_jackpot/particles/sparks_big/1.png',
    'res/common/progressive_jackpot/particles/sparks_big/2.png',
    'res/common/progressive_jackpot/particles/sparks_big/3.png',
    'res/common/progressive_jackpot/particles/sparks_big/4.png',
    'res/common/progressive_jackpot/particles/sparks_big/5.png',

    'res/common/progressive_jackpot/particles/sparks_small/0.png',
    'res/common/progressive_jackpot/particles/sparks_small/1.png',
    'res/common/progressive_jackpot/particles/sparks_small/2.png',
    'res/common/progressive_jackpot/particles/sparks_small/3.png',
    'res/common/progressive_jackpot/particles/sparks_small/4.png',
    'res/common/progressive_jackpot/particles/sparks_small/5.png',


    'res/common/progressive_jackpot/jp_credits_panel.png',
    'res/common/progressive_jackpot/fonts/jp_credits_font.xml',

    'res/common/progressive_jackpot/jp_ingame_panel.png',
    'res/common/progressive_jackpot/fonts/jp_bronze_font.xml',
    'res/common/progressive_jackpot/fonts/jp_green_font.xml',
    'res/common/progressive_jackpot/fonts/jp_white_font.xml',
    'res/common/progressive_jackpot/fonts/jp_gold_font.xml',

    'res/common/progressive_jackpot/jp_money_panel.png',
    'res/common/progressive_jackpot/fonts/jp_money_font.xml',
    'res/common/progressive_jackpot/fonts/jp_currency_font.xml',
];

var COMMON_HOWLER_RESOURCES = [
    'res/common/sounds/jackpot/impact',
    'res/common/sounds/jackpot/intro',
    'res/common/sounds/jackpot/loop_0',
    'res/common/sounds/jackpot/loop_1',
    'res/common/sounds/jackpot/loop_2',
    'res/common/sounds/jackpot/take',

    'res/common/sounds/roulette/bonus',
    'res/common/sounds/roulette/super_jackpot',
    'res/common/sounds/roulette/mega_jackpot',
    'res/common/sounds/roulette/jackpot',
    'res/common/sounds/roulette/impact',
    'res/common/sounds/roulette/gold',
    'res/common/sounds/roulette/end',
    'res/common/sounds/roulette/music',

    'res/common/sounds/progressive_jackpot/coins/music',
    'res/common/sounds/progressive_jackpot/coins/sound',
    // 'res/common/sounds/progressive_jackpot/coins/sync_sound',

    'res/common/sounds/progressive_jackpot/diamonds/music',
    'res/common/sounds/progressive_jackpot/diamonds/sound',
    // 'res/common/sounds/progressive_jackpot/diamonds/sync_sound',

    'res/common/sounds/progressive_jackpot/dollars/music',
    'res/common/sounds/progressive_jackpot/dollars/sound',
    // 'res/common/sounds/progressive_jackpot/dollars/sync_sound',


    'res/common/sounds/progressive_jackpot/galaxy/music',
    'res/common/sounds/progressive_jackpot/galaxy/sound',

    'res/common/sounds/progressive_jackpot/intro',
    'res/common/sounds/progressive_jackpot/gain_up',
    'res/common/sounds/progressive_jackpot/gain_stop'
];


function getUserInterfaceResources(config) {

    if ( SETTINGS.user_interface ) return SETTINGS.user_interface;

    switch (config.resolution.width) {
        case 1024:
            return ['res/common/userinterface_1024x768.json', 'res/common/fonts/userinterface1024x768-font.xml'];
        case 800:
            return ['res/common/userinterface_800x600.json', 'res/common/fonts/userinterface800x600-font.xml'];
    }

    return ['res/common/userinterface_1024x768.json', 'res/common/fonts/userinterface1024x768-font.xml'];
}

// prevent context menu on production
// it is the only place the jQuery included on
if (NODE_ENV == "production") {
    $(document).on("contextmenu", function (event) { event.preventDefault(); });
}


// if (SRS_ENV) {
//     console.log('!!!!!!!!!!!! CREATING VIDEO !!!!!!!!!!!!');
//
//     const video = document.createElement('video');
//     document.body.insertBefore(video, document.body.firstChild);
//     video.setAttribute('crossorigin',"anonymous");
//     video.setAttribute('id',"my-video");
//     video.setAttribute('width',"460");
//     video.setAttribute('height',"306");
//     video.setAttribute('loop',"loop");
//     video.setAttribute('autoplay',"true");
//     // video.setAttribute('style',"display: block;");
//
//     const source = document.createElement('source');
//     source.setAttribute('src',"http://136.243.152.82:8282");
//     source.setAttribute('type',"video/mp4; codecs=\'avc1.42E01E, mp4a.40.2\'");
//
//     video.appendChild(source);
//
//
//
//     // const input = Object.assign(document.createElement('input'), {
//     //     type:"hidden",
//     //     id:"token",
//     //     value:"0b4005adc63ca2effb20b2fa00db5c2d0874b151"
//     // });
//     // document.body.insertBefore(input, document.body.firstChild);
// }



function onResize( renderer, $resize ) {
    var doStretch = STRETCH_ENV !== 'false';
    //дизайнерское требование запретить растягивать игру по вертикали больше чем по горизонтали:
    // if (window.innerWidth / window.innerHeight < config.resolution.width / config.resolution.height) {
    if (window.innerWidth / window.innerHeight < SETTINGS.canvas.width / SETTINGS.canvas.height ) {
        doStretch = false;
    }

    if (doStretch) {
        stretch( renderer, $resize );
    }
    else {
        fit( renderer, $resize );
    }
}

/** Растянуть игру на весь экран с сохранением пропорций и отцентровать.*/
function fit( renderer, $resize ) {
    //change the ratio of the canvas based on current window size to resize it:
    var w, h;
    // var ratio = config.resolution.width / config.resolution.height;
    var ratio = SETTINGS.canvas.width / SETTINGS.canvas.height;

    if ( window.innerWidth / window.innerHeight >= ratio ) {
        w = window.innerHeight * ratio;
        h = window.innerHeight;
    }
    else {
        w = window.innerWidth;
        h = window.innerWidth / ratio;
    }



    renderer.view.style.width = w + 'px';
    renderer.view.style.height = h + 'px';

    //center canvas with weird "negative margins" approach (which proved to work on any browser starting from IE8):

    //trying to make it work on IE:
    renderer.view.style.position = 'fixed';
    renderer.view.style.display = "block";
    //renderer.view.style.display = "inline-block";
    renderer.view.style.left = "50%";
    renderer.view.style.top = "50%";

    renderer.view.style[ "margin-left" ] = "-" + w / 2 + "px";
    renderer.view.style[ "margin-top" ] = "-" + h / 2 + "px";

    $resize.next( { x : w, y : h } );
}

/** Растянуть игру на весь экран БЕЗ сохранений пропорций, занимая всё доступное пространство.*/
function stretch( renderer, $resize ) {
    renderer.view.style.position = "absolute";
    renderer.view.style.width = window.innerWidth + "px";
    renderer.view.style.height = window.innerHeight + "px";
    renderer.view.style.display = "block";

    //сбрасываем настройки которые могли установиться в fit():
    renderer.view.style[ "margin-left" ] = "0px";
    renderer.view.style[ "margin-top" ] = "0px";
    renderer.view.style.left = "0px";
    renderer.view.style.top = "0px";

    $resize.next( { x : window.innerWidth, y : window.innerHeight } );
}

function initScreen(screenConfig, $resize) {
    const scaleX = SETTINGS.canvas.width / screenConfig.resolution.width;
    const scaleY = SETTINGS.canvas.height / screenConfig.resolution.height;
    PIXI.renderer = PIXI.autoDetectRenderer(
        SETTINGS.canvas.width,
        SETTINGS.canvas.height,
        {antialias: false, transparent: false, resolution: 1}
    );
    PIXI.renderer.plugins.interaction.autoPreventDefault = true;// false

    rootContainer = new PIXI.Container();
    rootContainer.scale.set(scaleX, scaleY);

    document.body.insertBefore(PIXI.renderer.view, document.body.firstChild);

    const handle_resize = () => onResize( PIXI.renderer, $resize );
    window.addEventListener( 'resize', handle_resize );
    handle_resize();
}

let raf;

module.exports.mainDebug = function (screenConfig, resources, callback, animate) {
    animate = animate || (()=>{});

    let lastTime = performance.now();

    function debugAnimate() {
        const currentTime = performance.now();
        const dt = currentTime - lastTime;
        lastTime = currentTime;
        TWEEN.update(currentTime);
        animate(dt, currentTime);
        raf = requestAnimationFrame(debugAnimate);
        PIXI.renderer.render(rootContainer);
    }

    function boot() {

        SETTINGS.screen = screenConfig;
        SETTINGS.canvas = { width : 1366, height : 768 };

        initScreen(screenConfig, new Stream);

        let loadScene = new LoadScene(screenConfig);
        rootContainer.addChild(loadScene);

        popupScene = new PopupScene(screenConfig);
        rootContainer.addChild(popupScene);

        popupScene.showProcessIndicator();

        let serverLoadId = 1;
        let soundsLoadId = 2;
        let pixiLoadId = 3;
        const loadHandler = new LoadHandler(
            [
                {
                    fraction : 0,
                    id : serverLoadId
                },
                {
                    fraction : ( resources.howler.length / ( resources.howler.length + resources.pixi.length ) ),
                    id : soundsLoadId
                },
                {
                    fraction : ( resources.pixi.length / ( resources.howler.length + resources.pixi.length ) ),
                    id : pixiLoadId
                }
            ],
            () => {
                popupScene.hideProcessIndicator();
                loadScene.hideConnectionIndicator();
                // sceneManager.removeScene('LoadScene');
                rootContainer.removeChild(loadScene);
                loadScene.destroy(true);
                loadScene = null;

                callback(rootContainer);
            },
            portion => {
                loadScene.updateProgress( portion );
            }
        );

        sounds.load(
            resources.howler.concat(COMMON_HOWLER_RESOURCES),
            soundsLoadId,
            loadHandler
        );


        popupScene.hideNoConnectionBanner();
        loadScene.hideConnectionIndicator();
        loadHandler.loaded(serverLoadId);

        PIXI.loader.reset();

        const commonPixiResources = getUserInterfaceResources(screenConfig).concat(COMMON_PIXI_RESOURCES);

        PIXI.loader.add( resources.pixi.concat(commonPixiResources) )
            .on('progress', function (loader, resource) {
                //console.log("loading: " + resource.url);
                // console.log("progress: " + loader.progress + "%");
                //If you gave your files names as the first argument
                //of the `add` method, you can access them like this
                // console.log("loading: " + resource.name);

                loadHandler.progress(
                    pixiLoadId,
                    loader.progress / 100.0
                );
            })
            .on( 'error', function (e) {
                console.error(e);
            } )
            .load(function() {
                loadHandler.loaded(pixiLoadId);
            });

        debugAnimate();
    }

    // первоначальная загрузка элементов загрузочного экрана и служебных картинок
    PIXI.loader.add(LOADSCREEN_RECOURCES).load(boot);
};


module.exports.main = function(
    resources,
    construct,
    serverInfo,
    serverOptions,
    uiConfig,
    screenConfig,
    versionInfo
)
{
    PIXI_video_performance_fix()
    
    SETTINGS.screen = screenConfig;
    SETTINGS.canvas = SETTINGS.canvas || { width : 1366, height : 768 };

    function animate() {
        raf = requestAnimationFrame(animate);
        PIXI.renderer.render(rootContainer);
    }

    const server = new Server(
        serverInfo.gameNetworkId,
        serverInfo.gameName || "UNDEFINED",
        serverInfo.bonusUserSelectionsPolicy,
        serverInfo.totalizator
    );

    cancelCaching( versionInfo );

    // window.onerror = function myErrorHandler( messageOrEvent, source, lineno, colno, error ) {
    //     var failure = "Something failed: " + messageOrEvent + " at " + source + ", line " + lineno + ", column " + colno + ". Error: " + JSON.stringify( error );
    //     console.error(failure);
    //     server.printTalks();
    // };


    initLog();

    function boot() {

        const $resize = new Stream;

        initScreen(screenConfig, $resize );

        let loadScene = new LoadScene(screenConfig);
        rootContainer.addChild(loadScene);

        popupScene = new PopupScene(screenConfig);
        rootContainer.addChild(popupScene);

        popupScene.showProcessIndicator();

        let serverLoadId = 1;
        let soundsLoadId = 2;
        let pixiLoadId = 3;
        const loadHandler = new LoadHandler(
            [
                {
                    fraction : 0,
                    id : serverLoadId
                },
                {
                    fraction : ( resources.howler.length / ( resources.howler.length + resources.pixi.length ) ),
                    id : soundsLoadId
                },
                {
                    fraction : ( resources.pixi.length / ( resources.howler.length + resources.pixi.length ) ),
                    id : pixiLoadId
                }
            ],
            () => {
                popupScene.hideProcessIndicator();
                loadScene.hideConnectionIndicator();
                // sceneManager.removeScene('LoadScene');
                rootContainer.removeChild(loadScene);
                loadScene.destroy(true);
                loadScene = null;

                Init(
                    server,
                    construct,
                    serverOptions,
                    rootContainer,
                    popupScene,
                    uiConfig,
                    $resize
                );
            },
            portion => {
                loadScene.updateProgress( portion );
            }
        );

        console.log( "Is audio NOT supported: " + Howler.noAudio );

        let fatal = false;
        const onFatal = function ( message, instant, redirectUrl )
        {
            if ( fatal )
            {
                return;
            }
            fatal = true;

            console.error('FATAL ERROR: ' + message );
            popupScene.showFatalErrorBanner();
            popupScene.hideProcessIndicator();

            redirectUrl = redirectUrl || server.lobbyURL;
            if ( redirectUrl )
            {
                console.log( 'Will redirect to "' + redirectUrl + '" soon ...' );
                setTimeout(() => {
                        redirect( redirectUrl );
                    },
                    instant ? 1 : 5000
                );
            }
        };

        sounds.load(
            resources.howler.concat(COMMON_HOWLER_RESOURCES),
            soundsLoadId,
            loadHandler,
            url => cancelURLCaching( url, versionInfo )
        );

        //initialize server connection:
        const invokeHandleLobby = () => server.handleLobby(
            onSuccess,
            onFailure,
            onFatal,
            serverOptions
        );

        const onSuccess = () => {
            popupScene.hideNoConnectionBanner();
            loadScene.hideConnectionIndicator();
            loadHandler.loaded(serverLoadId);
        };

        const onFailure = error => {
            console.error( 'Failed to handle lobby: ' + error );
            popupScene.showNoConnectionBanner();
            popupScene.hideProcessIndicator();

            invokeHandleLobby();
        };

        invokeHandleLobby();

        //load resources with PIXI:
        PIXI.loader.reset();


        const commonPixiResources = getUserInterfaceResources(screenConfig).concat(COMMON_PIXI_RESOURCES);

        PIXI.loader.add( resources.pixi.concat(commonPixiResources) )
            .on('progress', function (loader, resource) {
                //console.log("loading: " + resource.url);
                // console.log("progress: " + loader.progress + "%");
                //If you gave your files names as the first argument
                //of the `add` method, you can access them like this
                // console.log("loading: " + resource.name);

                loadHandler.progress(
                    pixiLoadId,
                    loader.progress / 100.0
                );
            })
            .on( 'error', onFatal )
            .load(function() {
                loadHandler.loaded(pixiLoadId);
            });

        animate();
    }

    // первоначальная загрузка элементов загрузочного экрана и служебных картинок
    PIXI.loader.add(LOADSCREEN_RECOURCES).load(boot);
};

function initLog()
{
    var htmlElement = document.getElementById('log');

    if (HTMLLOG_ENV && NODE_ENV === 'development') {
        var oldLog = console.log;
        var oldError = console.error;

        var logger = function () {
            for (var i = 0; i < arguments.length; i++) {
                if (typeof arguments[i] == 'object') {
                    htmlElement.innerHTML += (JSON && JSON.stringify ? JSON.stringify(arguments[i], undefined, 2) : arguments[i]) + '<br />';
                } else {
                    htmlElement.innerHTML += arguments[i] + '<br />';
                }
            }

            // jQuery(function () {
            //     var log = jQuery("#log");
            //     log.scrollTop(log.prop("scrollHeight"));
            // })

        };

        console.log = function()
        {
            logger.apply( this, arguments );
            oldLog.apply( this, arguments );
        };
        console.error = function()
        {
            logger.apply( this, arguments );
            oldError.apply( this, arguments );
        };
    }
    else {
        if (htmlElement && htmlElement.parentNode) {
            htmlElement.parentNode.removeChild(htmlElement);
        }
    }
}

function redirect( to )
{
    window.location.replace( to );
}

function cancelCaching( versionInfo )
{
    //cannot yet implement it for PIXI V3:
    if ( PIXI.version == 3 ) return
    
    const uq = '?' + ( versionInfo ? encodeURI( versionInfo.build ) : ( new Date() ).getTime() );
    var originalAdd = PIXI.loader.add;
    PIXI.loader.add = function()
    {
        //throughout the project resources are referenced the same way they're loaded so when we alter the URL to cancel caching they can't be referenced anymore (only sole ones - those without json wrappers), but PIXI allows specifying name separately from path so we define our own args:
        const newArgs = Array.prototype.slice.call( arguments );
        switch ( arguments.length )
        {
            case 1:
                //no need to handle array since I know (it's not defined by API :( ) that PIXI just calles this function again with all the array values one-by-one ...
                if ( typeof arguments[ 0 ] === 'string' )
                {
                    newArgs[ 1 ] = cancelURLCaching( arguments[ 0 ], versionInfo );
                }
                break;

            //that's how PIXI loads resources parsed out from .json files:
            case 4:
                newArgs[ 1 ] = cancelURLCaching( arguments[ 1 ], versionInfo );
                break;

            default:
                console.warn( 'PIXI: Unknown resources load spec.' );
                break;
        }

        return originalAdd.apply( PIXI.loader, newArgs );
    };
}

function cancelURLCaching( URL, versionInfo )
{
    return URL + '?' + ( versionInfo ? encodeURI( versionInfo.build ) : ( new Date() ).getTime() );
}



// WEBPACK FOOTER //
// ./src/library/boot.es6